import { Box, Menu, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Button } from '../../../components';

export const StyledFilterCard = styled(Box)(({ theme }) => ({
  ...(theme.palette.mode === 'dark'
    ? { boxShadow: 'none', border: `1px solid ${theme.palette.divider}` }
    : { boxShadow: '0px 18px 32px 16px rgba(193, 193, 193, 0.16)' }),
  background: theme.palette.background.paper,
  borderRadius: '16px',
  padding: '14px 16px',
}));

export const StyledControlsBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  height: '100%',
  gap: '8px',
});

export const StyledSortMenu = styled(Menu)({
  marginTop: '45px',
  '& span': {
    paddingLeft: '2px',
    color: 'text.secondary',
    fontStyle: 'italic',
  },
});

export const StyledButton = styled(Button)({
  padding: '4px 10px !important',
  height: 35,
});

export const CompanyFilterToggle = styled(ToggleButtonGroup)(({ theme }) => ({
  height: 24,
  '& .MuiToggleButton-root': {
    padding: '2px 8px',
    fontSize: '11px',
    fontFamily: theme.typography.fontFamily,
    textTransform: 'none',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.dark,
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
}));

export const CompanyFilterToggleButton = styled(ToggleButton)({});

export const ProtectedDomainsToggle = CompanyFilterToggle;

export const ProtectedDomainsToggleButton = CompanyFilterToggleButton;
